import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Route } from '@/constants';
import { useCreateUserMutation } from '@/features/slice/users';
import { useGetRoleQuery } from '@/features/slice/users/roles.permission/role-permission-api-slice';
import { TCreateUserForm } from '@/modules/users/create-user/create-user.schema';
import { toastError } from '@/utils';

export const useCreateUser = () => {
    const { data: rolesData, isLoading, isFetching } = useGetRoleQuery({});

    const [createUser, { isLoading: isUserCreating }] = useCreateUserMutation();

    const navigate = useNavigate();

    const roleOptions = rolesData?.data?.map((role: any) => {
        return { label: role.name, value: role.id.toString() };
    });

    const handleSubmit = async (formData: TCreateUserForm) => {
        try {
            await createUser(formData).unwrap();
            toast.success('User created successfully.');
            setTimeout(() => navigate(Route.USERS), 0);
        } catch (error) {
            toastError(error, 'useCreateUser -> handleSubmit');
        }
    };

    return {
        handleSubmit,

        roleOptions: roleOptions || [],
        isRolesLoading: isLoading || isFetching,
        isUserCreating,
    };
};
